import * as React from "react";
const SvgFiRrSecond = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M10 11a1 1 0 1 0 0-2H9V8a1 1 0 1 0-2 0v1H4V8a1 1 0 1 0-2 0v1H1a1 1 0 1 0 0 2h1v3H1a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0v-1h3v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2H9v-3zm-3 3H4v-3h3zm17 7a1 1 0 0 1-1 1h-8.325a2.64 2.64 0 0 1-2.442-1.588 2.64 2.64 0 0 1 .463-2.88c.962-1.064 2.327-2.045 3.771-3.084C19.187 12.493 22 10.471 22 8c0-2.206-1.794-4-4-4-1.921 0-3.65 1.375-4.02 3.199-.11.54-.637.885-1.179.781a1 1 0 0 1-.781-1.18c.565-2.781 3.08-4.801 5.98-4.801 3.309 0 6 2.691 6 6 0 3.496-3.382 5.928-6.365 8.072-1.355.975-2.636 1.896-3.456 2.802a.66.66 0 0 0-.118.728.65.65 0 0 0 .614.398H23A1 1 0 0 1 24 21"
    />
  </svg>
);
export default SvgFiRrSecond;
